import * as React from "react";
import type { SVGProps } from "react";
const SvgTicketGeneral = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g fill="currentColor" clipPath="url(#ticket-general_svg__a)">
      <path d="M21 21H3a3 3 0 0 1-3-3v-4a1 1 0 0 1 1-1 1 1 0 0 0 0-2 1 1 0 0 1-1-1V6a3 3 0 0 1 3-3h18a3 3 0 0 1 3 3v4a1 1 0 0 1-1 1 1 1 0 0 0 0 2 1 1 0 0 1 1 1v4a3 3 0 0 1-3 3M2 14.83V18a1 1 0 0 0 1 1h18a1 1 0 0 0 1-1v-3.17a3 3 0 0 1 0-5.66V6a1 1 0 0 0-1-1H3a1 1 0 0 0-1 1v3.17a3 3 0 0 1 0 5.66" />
      <path d="M15 8a1 1 0 0 1-1-1V5a1 1 0 0 1 2 0v2a1 1 0 0 1-1 1M15 14a1 1 0 0 1-1-1v-2a1 1 0 0 1 2 0v2a1 1 0 0 1-1 1M15 20a1 1 0 0 1-1-1v-2a1 1 0 0 1 2 0v2a1 1 0 0 1-1 1" />
    </g>
    <defs>
      <clipPath id="ticket-general_svg__a">
        <path fill="#fff" d="M0 3h24v18H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgTicketGeneral;
